<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit League</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Name</label>
            <input class="form-control" [(ngModel)]="name" type="text">
          </div>
          <div class="col-sm-6">
            <label>Tier</label>
            <input class="form-control" [(ngModel)]="tier" type="number" min="0">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Previous League</label>
            <select class="form-control" [(ngModel)]="leaguePreviousId">
              <option [ngValue]="null">— None —</option>
              @for (l of leagues; track l.leagueId) {
                <option [ngValue]="l.leagueId">{{ l.name }} (Tier {{ l.tier }})</option>
              }
            </select>
          </div>
          <div class="col-sm-6">
            <label>Next League</label>
            <select class="form-control" [(ngModel)]="leagueNextId">
              <option [ngValue]="null">— None —</option>
              @for (l of leagues; track l.leagueId) {
                <option [ngValue]="l.leagueId">{{ l.name }} (Tier {{ l.tier }})</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Free Credits Bonus (%)</label>
            <input class="form-control" [(ngModel)]="freeCreditsBonus" type="number" min="0" step="0.01">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
